import React, { ReactElement } from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'
import HomeIcon from '@material-ui/icons/Home'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined'
import SearchIcon from '@material-ui/icons/Search'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined'
import PhoneIcon from '@material-ui/icons/Phone'
import MailIcon from '@material-ui/icons/MailOutlined'

import Alert from '../../../../static/img/svgIcons/alert.inline.svg'
import ArrowDown from '../../../../static/img/svgIcons/arrow_down.inline.svg'
import ArrowLeft from '../../../../static/img/svgIcons/arrow_left.inline.svg'
import ArrowScrollDown from '../../../../static/img/svgIcons/arrow_scroll_down.inline.svg'
import ArrowTeaser from '../../../../static/img/svgIcons/arrow_teaser.inline.svg'
import ArrowUp from '../../../../static/img/svgIcons/arrow_up.inline.svg'
import More from '../../../../static/img/svgIcons/more.inline.svg'
import LinkArrowRight from '../../../../static/img/svgIcons/arrow_link_right.inline.svg'
import ChartCheck from '../../../../static/img/svgIcons/chart_check.inline.svg'
import ChartNoCheck from '../../../../static/img/svgIcons/chart_nocheck.inline.svg'
import Close from '../../../../static/img/svgIcons/close.inline.svg'
import Descale from '../../../../static/img/svgIcons/descale.inline.svg'
import Download from '../../../../static/img/svgIcons/download.inline.svg'
import DownloadColored from '../../../../static/img/svgIcons/download_colored.inline.svg'
import Duration from '../../../../static/img/svgIcons/dauer.inline.svg'
import EasyLang from '../../../../static/img/svgIcons/easy_lang.inline.svg'
import Facebook from '../../../../static/img/svgIcons/facebook.inline.svg'
import IlluBeginner from '../../../../static/img/svgIcons/illu_anfaenger.inline.svg'
import IlluBike from '../../../../static/img/svgIcons/illu_fahrrad.inline.svg'
import IlluCar from '../../../../static/img/svgIcons/illu_pkw.inline.svg'
import IlluChildren from '../../../../static/img/svgIcons/illu_kinder.inline.svg'
import IlluCommercial from '../../../../static/img/svgIcons/illu_berufskraftfahrer.inline.svg'
import IlluMotorcycle from '../../../../static/img/svgIcons/illu_motorrad.inline.svg'
import IlluPedestrian from '../../../../static/img/svgIcons/illu_fussgaenger.inline.svg'
import IlluSeniors from '../../../../static/img/svgIcons/illu_senioren.inline.svg'
import Instagram from '../../../../static/img/svgIcons/instagram.inline.svg'
import Kununu from '../../../../static/img/svgIcons/kununu.inline.svg'
import Linkedin from '../../../../static/img/svgIcons/linkedin.inline.svg'
import Layers from '../../../../static/img/svgIcons/layers.inline.svg'
import LockIcon from '../../../../static/img/svgIcons/lock.inline.svg'
import Menu from '../../../../static/img/svgIcons/menu.inline.svg'
import PaginationPrev from '../../../../static/img/svgIcons/pagination_prev.inline.svg'
import PaginationNext from '../../../../static/img/svgIcons/pagination_next.inline.svg'
import Quote from '../../../../static/img/svgIcons/quote.inline.svg'
import Scale from '../../../../static/img/svgIcons/scale.inline.svg'
import SearchEmpty from '../../../../static/img/svgIcons/search_empty.inline.svg'
import SfFamily from '../../../../static/img/svgIcons/sf_family.inline.svg'
import StagePause from '../../../../static/img/svgIcons/button_stage_pause.inline.svg'
import StagePlay from '../../../../static/img/svgIcons/button_stage_play.inline.svg'
import Twitter from '../../../../static/img/svgIcons/twitter.inline.svg'
import ShareXING from '../../../../static/img/svgIcons/share_xing.inline.svg'
import ShareLinkedIn from '../../../../static/img/svgIcons/share_linkedin.inline.svg'
import ShareFacebook from '../../../../static/img/svgIcons/share_facebook.inline.svg'
import ShareTwitter from '../../../../static/img/svgIcons/share_twitter.inline.svg'
import ShareEMail from '../../../../static/img/svgIcons/share_email.inline.svg'
import Spotify from '../../../../static/img/svgIcons/spotify.inline.svg'
import YouTubePlay from '../../../../static/img/svgIcons/youtube_play.inline.svg'

export type IconProps = {
  className?: string
  name: string
  size?: 'inherit' | 'default' | 'small' | 'large'
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'action'
    | 'disabled'
    | 'error'
    | 'white'
    | 'black'
}

export default function Icon({
  className,
  name,
  size,
  color,
}: IconProps): ReactElement | null {
  function renderIcon() {
    const svgProps = {
      fontSize: size,
      color: color,
      className: className,
    }
    const illuProps = {
      ...svgProps,
      viewBox: '0 0 64 64',
      style: { fontSize: 64 },
    }
    switch (name) {
      case 'Alert':
        return (
          <SvgIcon {...illuProps}>
            <Alert />
          </SvgIcon>
        )
      case 'ArrowDown':
        return (
          <SvgIcon {...svgProps}>
            <ArrowDown />
          </SvgIcon>
        )
      case 'ArrowUp':
        return (
          <SvgIcon {...svgProps}>
            <ArrowUp />
          </SvgIcon>
        )
      case 'More':
        return (
          <SvgIcon {...svgProps}>
            <More />
          </SvgIcon>
        )
      case 'ArrowLeft':
        return (
          <SvgIcon {...svgProps}>
            <ArrowLeft />
          </SvgIcon>
        )
      case 'ArrowScrollDown':
        return (
          <SvgIcon {...svgProps}>
            <ArrowScrollDown />
          </SvgIcon>
        )
      case 'LinkArrowRight':
        return (
          <SvgIcon {...svgProps}>
            <LinkArrowRight />
          </SvgIcon>
        )
      case 'ArrowTeaser':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 16 16' }}>
            <ArrowTeaser />
          </SvgIcon>
        )
      case 'Lock':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <LockIcon />
          </SvgIcon>
        )
      case 'Basket':
        return <ShoppingBasketIcon {...svgProps} />
      case 'ChevronDown':
        return <ExpandMoreIcon {...svgProps} />
      case 'ChevronLeft':
        return <ChevronLeftIcon {...svgProps} />
      case 'ChevronRight':
        return <ChevronRightIcon {...svgProps} />
      case 'ChevronUp':
        return <ExpandLessIcon {...svgProps} />
      case 'Close':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <Close />
          </SvgIcon>
        )
      case 'Description':
        return <DescriptionOutlinedIcon {...svgProps} />
      case 'Download':
        return (
          <SvgIcon {...svgProps}>
            <Download />
          </SvgIcon>
        )
      case 'DownloadColored':
        return (
          <SvgIcon {...svgProps}>
            <DownloadColored />
          </SvgIcon>
        )
      case 'Duration':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 16 16' }}>
            <Duration />
          </SvgIcon>
        )
      case 'EasyLang':
        return (
          <SvgIcon {...svgProps}>
            <EasyLang />
          </SvgIcon>
        )
      case 'Facebook':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 32 32' }}>
            <Facebook />
          </SvgIcon>
        )
      case 'Home':
        return <HomeIcon {...svgProps} />
      case 'IlluBeginner':
        return (
          <SvgIcon {...illuProps}>
            <IlluBeginner />
          </SvgIcon>
        )
      case 'IlluBike':
        return (
          <SvgIcon {...illuProps}>
            <IlluBike />
          </SvgIcon>
        )
      case 'IlluCar':
        return (
          <SvgIcon {...illuProps}>
            <IlluCar />
          </SvgIcon>
        )
      case 'IlluChildren':
        return (
          <SvgIcon {...illuProps}>
            <IlluChildren />
          </SvgIcon>
        )
      case 'IlluCommercial':
        return (
          <SvgIcon {...illuProps}>
            <IlluCommercial />
          </SvgIcon>
        )
      case 'IlluMotorcycle':
        return (
          <SvgIcon {...illuProps}>
            <IlluMotorcycle />
          </SvgIcon>
        )
      case 'IlluPedestrian':
        return (
          <SvgIcon {...illuProps}>
            <IlluPedestrian />
          </SvgIcon>
        )
      case 'IlluSeniors':
        return (
          <SvgIcon {...illuProps}>
            <IlluSeniors />
          </SvgIcon>
        )
      case 'Kununu':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <Kununu />
          </SvgIcon>
        )
      case 'Layers':
        return (
          <SvgIcon {...svgProps}>
            <Layers />
          </SvgIcon>
        )
      case 'Mail':
        return <MailIcon {...svgProps} />
      case 'Menu':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <Menu />
          </SvgIcon>
        )
      case 'OpenInNew':
        return <OpenInNewIcon {...svgProps} />
      case 'PaginationPrev':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 16 16' }}>
            <PaginationPrev />
          </SvgIcon>
        )
      case 'PaginationNext':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 16 16' }}>
            <PaginationNext />
          </SvgIcon>
        )
      case 'Phone':
        return <PhoneIcon {...svgProps} />
      case 'Print':
        return <PrintOutlinedIcon {...svgProps} />
      case 'Quote':
        return (
          <SvgIcon
            {...{
              ...svgProps,
              viewBox: '0 0 84 24',
            }}
          >
            <Quote />
          </SvgIcon>
        )
      case 'Scale':
        return (
          <SvgIcon {...svgProps}>
            <Scale />
          </SvgIcon>
        )
      case 'Descale':
        return (
          <SvgIcon {...svgProps}>
            <Descale />
          </SvgIcon>
        )
      case 'Search':
        return <SearchIcon {...svgProps} />
      case 'SearchEmpty':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 222 134' }}>
            <SearchEmpty />
          </SvgIcon>
        )
      case 'Speech':
        return <ForumOutlinedIcon {...svgProps} />
      case 'Twitter':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <Twitter />
          </SvgIcon>
        )
      case 'Instagram':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <Instagram />
          </SvgIcon>
        )
      case 'LinkedIn':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <Linkedin />
          </SvgIcon>
        )
      case 'YouTubePlay':
        return (
          <SvgIcon
            {...{
              ...svgProps,
              viewBox: '0 0 68 49',
            }}
            style={{
              width: '68px',
              height: '49px',
            }}
          >
            <YouTubePlay {...svgProps} />
          </SvgIcon>
        )
      case 'StagePlay':
        return (
          <SvgIcon
            {...{ ...svgProps, viewBox: '0 0 54 54' }}
            style={{
              width: '54px',
              height: '54px',
            }}
          >
            <StagePlay />
          </SvgIcon>
        )
      case 'StagePause':
        return (
          <SvgIcon
            {...{ ...svgProps, viewBox: '0 0 54 54' }}
            style={{
              width: '54px',
              height: '54px',
            }}
          >
            <StagePause />
          </SvgIcon>
        )
      case 'ChartCheck':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <ChartCheck />
          </SvgIcon>
        )
      case 'ChartNoCheck':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <ChartNoCheck />
          </SvgIcon>
        )
      case 'SfFamily':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 124 132' }}>
            <SfFamily />
          </SvgIcon>
        )
      case 'shareXING':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <ShareXING />
          </SvgIcon>
        )
      case 'shareLinkedIn':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <ShareLinkedIn />
          </SvgIcon>
        )
      case 'shareFacebook':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <ShareFacebook />
          </SvgIcon>
        )
      case 'shareTwitter':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <ShareTwitter />
          </SvgIcon>
        )
      case 'shareEMail':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <ShareEMail />
          </SvgIcon>
        )
      case 'Spotify':
        return (
          <SvgIcon {...{ ...svgProps, viewBox: '0 0 24 24' }}>
            <Spotify />
          </SvgIcon>
        )
      default:
        return null
    }
  }
  return renderIcon()
}
